import { render, staticRenderFns } from "./transactions-table.vue?vue&type=template&id=1f0b4421&scoped=true"
import script from "./transactions-table.vue?vue&type=script&lang=js"
export * from "./transactions-table.vue?vue&type=script&lang=js"
import style0 from "./transactions-table.vue?vue&type=style&index=0&id=1f0b4421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b4421",
  null
  
)

export default component.exports